import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=7e0686b0"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"
import style0 from "./Producto.vue?vue&type=style&index=0&id=7e0686b0&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports